export const campaignSections = ["campaigns", "contacts", "analytics", "create"] as const;
export type CampaignSection = typeof campaignSections[number];

export function campaignSectionFromSearch(search: URLSearchParams): CampaignSection {
  const section = search.get("section");
  return campaignSections.includes(section as CampaignSection) ? section as CampaignSection : "campaigns";
}

export function campaignSearch(previous: URLSearchParams, section: CampaignSection, campaignId = "") {
  const next = new URLSearchParams(previous);
  next.set("section", section);
  if (section === "analytics" && campaignId) next.set("campaignId", campaignId);
  else next.delete("campaignId");
  return next;
}
